import React, { useEffect, useRef } from "react";

const PositionedDialog = ({ anchorRef, open, close, title, bodyContent }) => {
  const popperRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target) &&
        !anchorRef.current.contains(event.target)
      ) {
        close(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, close, anchorRef]);

  // Calculate position
  const getPosition = () => {
    if (!anchorRef.current) return { top: 0, left: 0 };
    const rect = anchorRef.current.getBoundingClientRect();
    return {
      top: rect.bottom + window.scrollY + 8, // 8px offset
      left: rect.left + window.scrollX,
    };
  };

  if (!open) return null;

  const { top, left } = getPosition();

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={() => close(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1000,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      />

      {/* Popper */}
      <div
        ref={popperRef}
        style={{
          position: "absolute",
          top,
          left,
          zIndex: 1100,
          background: "#fff",
          borderRadius: "8px",
          padding: "16px",
          width: "300px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          transition: "opacity 0.3s ease, transform 0.3s ease",
          opacity: open ? 1 : 0,
          transform: open ? "translateY(0)" : "translateY(-10px)",
        }}
      >
        {title && <h3 style={{ margin: "0 0 12px" }}>{title}</h3>}
        {bodyContent && <div>{bodyContent}</div>}
      </div>
    </>
  );
};

export default PositionedDialog;
